import { FixedEligibilityBanner } from "../FixedEligibilityBanner";
import { FixedPricingBanner } from "../FixedPricingBanner";
import { GridV2MinimumRedemptionBanner } from "../GridV2MinimumRedemptionBanner";
import { PointsEligibilityBanner } from "../PointsEligibilityBanner";
import { GridV2Gate } from "@/modules/grid-v2/GridV2Gate";
import type { PricingMode } from "@/store/flights/shop/store/slice";

interface FlightShopHeaderBannerProps {
  isFixedPriceRoute: boolean;
  pricingMode: PricingMode;
  flightListLength: number;
  className?: string;
}

export const FlightShopHeaderBanner = ({
  isFixedPriceRoute,
  pricingMode,
  flightListLength,
  className,
}: FlightShopHeaderBannerProps) => {
  return (
    <>
      {/* The points banners have internal conditional logic based on points balance data.
          They're always rendered to encapsulate their own display conditions rather than duplicating
          that logic here. Each returns null when conditions aren't met. */}
      <GridV2Gate fallback={<PointsEligibilityBanner className={className} />}>
        <GridV2MinimumRedemptionBanner className={className} />
      </GridV2Gate>
      {isFixedPriceRoute && pricingMode === "fixed" && (
        <FixedPricingBanner className={className} />
      )}
      {!isFixedPriceRoute && flightListLength !== 0 && (
        <FixedEligibilityBanner className={className} />
      )}
    </>
  );
};
